import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import Chart from 'chart.js/auto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { first } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

 barchat: any;
  data: any;
  keyvalue:any;
  regob:any
  piechartdata: any;
  dashboardcarddata: any;
  appob: any;
  activeob: any;
  districtname: any;
  customers: any;
   spinner: boolean;
  tableshow: boolean = false;
  dtOptions: DataTables.Settings = {};
  uploadFiles: any = [];
  uploadFilename: any = [];
  count: any = 0;
  image: any = '';
  ob_status: string = 'Completed';
  ob_comments: string = '';
  createmeetingform !: FormGroup;
  user_activity_id: any;
  district: any = this.ApiService.district;
  constituency: any = this.ApiService.constituency;
  user_district: any = this.ApiService.user_details.district;
  user_constituency: any = this.ApiService.user_details.constituency;
  count_activity: any;
  users: any = JSON.parse(localStorage.getItem('login_user_details'));
  courses_assigned_to: any;

  

  // ApiServiceService: any;


   constructor(private fb: FormBuilder,private ApiService: ApiServiceService,private router:Router,private spinnerService: NgxSpinnerService,
     public datepipe: DatePipe, private elementRef: ElementRef, private renderer: Renderer2) { 
     this.createmeetingform= this.fb.group({
      user_name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
       ob_status: ['', Validators.required],
       ob_comments: ['', Validators.required],
      
    });
     }
  user_name: any = this.ApiService.user_details.firstname;
  user_id: any = this.ApiService.user_details.id;

   ngOnInit(): void {
 this.districtname=JSON.parse(localStorage.getItem('user_district'));
 console.log(this.districtname)
 console.log('this.districtname')

     
     this.ApiService.courseAssignedToMentor(this.users.first_name).subscribe((data: any) => {
       console.log(data, "sknsdnjs");
       this.courses_assigned_to = data;  
     })
     
     
       this.ApiService.viewOfficeBarriersActivity(this.districtname,this.user_constituency).subscribe((data: any) => {
      console.log(data,"s,mfdnsd");
     
      this.customers=data;
      this.tableshow=true;
      //console.log(this.customers.length);
      //console.log(obj.data.length);
      console.log(this.customers,"dsdksbk");
      ;})
    
         this.ApiService.dashboardcardda(this.districtname).subscribe((cardata:any) => {
          // console.log('card');
         this.dashboardcarddata=cardata;
         console.log(this.dashboardcarddata);
         let obj= this.dashboardcarddata;
       this.regob=obj.REGOB;
       this.appob=obj.APPOB;
       this.activeob=obj.ACTIVEOB;

           ;})
    this.dtOptions = {
      pagingType: 'full_numbers'
    };

   }
  
  selectFiles(event:any) {
    console.log(event.target.files[0].name, "dnjsndk");
    if (event.target.files[0].size < 60000) {
    if (this.uploadFiles.length < 5) {
      $('#title').css('display', 'block');
      this.spinner = true;
      
      const formData: FormData = new FormData();
      formData.append('file', event.target.files[0]);
      this.ApiService.uploadActivityFile(formData).subscribe((da: any) => {
        this.uploadFiles.push(da);
        this.spinner = false;
        $('#list').append(`<label class="form-label">${event.target.files[0].name}</label>`)
      })
    } else {
      alert('The file upload should be 5 or less than 5');
    }
    } else {
      alert('The size should be less than 60kb');
      $('#file').val('');
    }
    
  }

  activity: any;
  activity_type: any;
  assigned_to: any;
  activity_constituency: any;
  activity_date: any;
  time: any;
  description: any;
  activity_district: any;
  others: any;
  activity_time: any;
  
  handleEdit(editForm: any) {
    console.log(editForm, "dmnsdnksjnsjn");
    this.user_activity_id = editForm.id;
    this.activity = editForm.activity;
    this.activity_type = editForm.activity_type;
    this.activity_constituency = editForm.activity_constituency;
    this.activity_date = editForm.date;
    this.time = editForm.time;
    this.description = editForm.description;
  }
  postdata(form: any) {
    console.log(form.value.ob_status, "sskn"); 

    const array = {
      'status': 'Completed',
      'comments': form.value.ob_comments,
      'user_activity_id': this.user_activity_id,
      'images': this.uploadFiles,
      'user_id': this.user_id,
    }
    this.spinner=true;
    this.ApiService.updateOBActivity(array).subscribe((data) => {
     this.spinnerService.hide();
     setTimeout(function () {
      Swal.fire({
        title: "OB Task/Activity has been created successfully!",
        icon: "success",
        confirmButtonText: "Okay",
        iconColor: "#015792" // Set the icon color here
      }).then(() => {
        window.location.reload();
      });
    }, 100);
    
    })
  }

   CM_course_name: any;
  CM_district: any;
  CM_constituency: any;
  CM_organizer: any;
  CM_startDate: any;
  CM_endDate: any;
  CM_startTime: any;
  CM_endTime: any;
  CM_volunteer1: any;
  CM_volunteer2: any;
  CM_location: any;
  CM_status: any;
  CM_comments: any;
  CM_session_link: any;
   CM_id: any;
  editmeetingform !:FormGroup;



  editfield:boolean=false;
  buttonviewmeeting(a:any,editbutton:any ){
    console.log(a,editbutton);
    //console.log(a.date)
    if (editbutton == 'edit') {
      this.editfield = true;
    } else {
      this.editfield = false;
    }
      this.CM_course_name=a.course_name;
          this.CM_district=a.district;
          this.CM_constituency=a.constituency;
   this.CM_startDate = this.datepipe.transform(a.start_date, 'dd-MM-yyyy');
    this.CM_organizer = a.organizer;
          this.CM_endDate=this.datepipe.transform(a.end_date, 'dd-MM-yyyy');
          this.CM_startTime=a.start_time;
          this.CM_endTime=a.end_time;
          this.CM_volunteer1=a.volunteer1;
    this.CM_volunteer2 = a.volunteer2;
    this.CM_location = a.location;
    this.CM_status = a.status;
    this.CM_comments = a.comments;
    this.CM_session_link = a.session_link;
    this.CM_id = a.id;
    this.editmeetingform.get('comments').setValue(a.comments);
    this.editmeetingform.get('session_link').setValue(a.session_link);
    this.editmeetingform.get('course_name').setValue(a.course_name);
    this.editmeetingform.get('organizer').setValue(a.organizer);
      
          //this.editformInitialize(false);
      
   
    // this.editmeetingform.get('meeting_date').setValue(a.date);
    // this.editmeetingform.get('meeting_time').setValue(a.time);
          //this.editmeetingform.controls['meeting_date'].disable();
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_date);
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_time);

    }
   
}
